import React from 'react'

import { InputControls } from 'components/common'

import './styles.scss'

const CheckField = ({ action, isChecked }) =>
  <InputControls
    injectType='external'
    className='checkOptions filterTable'
    type='checkbox'
    value={isChecked}
    onChange={value => action(value)}
    color='newPrimary'
  />

export default CheckField
